var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBellIcon = function SvgBellIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8 0c-.553 0-1 .447-1 1v.1A5 5 0 0 0 3 6v.678a6.64 6.64 0 0 1-1.45 4.138l-.306.38A1.11 1.11 0 0 0 2.11 13h11.778a1.11 1.11 0 0 0 .865-1.802l-.306-.381A6.65 6.65 0 0 1 13 6.678V6a5 5 0 0 0-4-4.9V1c0-.553-.447-1-1-1M6.063 14.5a2.002 2.002 0 0 0 3.875 0z"
  })));
};
export default SvgBellIcon;